<app-dialog
        headerText="Read-Access Granted"
        [showCancelButton]="false"
        saveText="Close"
        [showTopCancelButton]="false"
        [body]="body"
        [saveButtonType]="'transparent'"
        (save)="onClose()">
    <ng-template #body>
        <div>
            <p style="margin: 0; font-size: 14px; line-height: 1.5;">
                We’ve added you as a principal in the managed service to grant you read permissions for the type in the referenced RTD.
            </p>
        </div>
    </ng-template>
</app-dialog>
